import { render, staticRenderFns } from "./SuffixNumberFormattedInput.vue?vue&type=template&id=5b74801f&"
import script from "./SuffixNumberFormattedInput.vue?vue&type=script&lang=ts&"
export * from "./SuffixNumberFormattedInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports